import { render } from "./deomUrl.vue?vue&type=template&id=b36375b6&scoped=true"
import script from "./deomUrl.vue?vue&type=script&lang=js"
export * from "./deomUrl.vue?vue&type=script&lang=js"

import "./deomUrl.vue?vue&type=style&index=0&id=b36375b6&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36375b6"]])

export default __exports__